export default "__VITE_ASSET__DXbCTY28__"